import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  TextField,
  Button,
  Stack,
  CircularProgress,
  Alert,
  Box,
  Paper,
} from "@mui/material";
import AreaSelector from "../components/AreaSelector"; 
import {toast} from "react-toastify"
import { getVideoDetailsAPI, updateVideoMarketAPI } from "../apis/videos.apis";

const EditVideoMarkets = () => {
  const [videoInput, setVideoInput] = useState("");
  const [videoData, setVideoData] = useState(null);
  const [areaData, setAreaData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState(null);

  const handleSearch = async () => {
    setLoading(true);
    setVideoData(null);
    setStatusMessage(null);
    try {
      const data = await getVideoDetailsAPI(videoInput);
      setVideoData(data.video_details);
    } catch (err) {
        setVideoInput("");
setVideoData(null);
setAreaData(null);
        toast.error("Video not found.");
    } finally {
      setLoading(false);
    }
  };

  const handleAreaChange = (data) => {
    setAreaData(data);
  };

  const handleUpdate = async () => {
    if (!videoData || !areaData?.zone?.id || !areaData?.state?.id || !areaData?.city?.id) {
        toast.error("Please select all fields.");
      return;
    }

    try {
      await updateVideoMarketAPI(videoData.id, {
        zone_id: areaData.zone.id,
        state_id: areaData.state.id,
        city_id: areaData.city.id,
      });
      setVideoInput("");
setVideoData(null);
setAreaData(null);
      toast.success("Video market updated successfully.");
    } catch (err) {
        toast.error("Failed to update video market.");
    }
  };

  return (
    <>
      <AppBar position="relative">
        <Toolbar>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Edit Video Markets
          </Typography>
        </Toolbar>
      </AppBar>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 4,
          px: 2,
        }}
      >
        <Paper elevation={3} sx={{ maxWidth: 600, width: "100%", p: 4 }}>
          <Stack spacing={3}>
            <TextField
              label="Enter Video Filename or ID"
              variant="outlined"
              fullWidth
              value={videoInput}
              onChange={(e) => setVideoInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            />
            <Button variant="contained" onClick={handleSearch} disabled={loading}>
              {loading ? <CircularProgress size={24} /> : "Search Video"}
            </Button>

            {videoData && (
              <>
                <Typography variant="h6">
                  Update Market for: {videoData.filename}
                </Typography>
                <AreaSelector onChange={handleAreaChange} />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleUpdate}
                >
                  Save Changes
                </Button>
              </>
            )}
          </Stack>
        </Paper>
      </Box>
    </>
  );
};

export default EditVideoMarkets;
